export const styleJoin = {
    inputStyle: { backgroundColor: '#fff',
        color: '#333' },
    buttonStyle: { pointerEvents: 'all',
        cursor: 'pointer' },
    h6Style: { color: '#FFF' },
    h4Style: { marginTop: '1%',
        marginBottom: '4%',
        color: '#FFF' },
    joinMargin: {
        marginTop: '65px',
        marginBottom: '34px'
    }


};
